export const AppConfig = {
	
	// Sync with stores collection
	stores: {
		store1: {
			slug: 'scholar-quest-assessments',
			label: 'Assessment',
		},
		store2: {
			slug: 'scholar-quest-olympiads',
			label: 'Olympiad',
		}
	},
	
	// Support Contact Details
	contacts: {
		contact1: {
			contact: '84228 87582', // use for display
			contactVal: '8422887582' // use for anchor tag tel
		}
	},

	emails: {
		email1: 'contact@hubblehox.com', 
	},
	// Hubblestar application using this value
	hubbleSTARClientID: 'OSEHUB'
};
